import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin, Zap } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <Zap size={24} className="text-primary-500" />
              <span className="text-xl font-black text-gray-900 dark:text-white">
                Python Learning
              </span>
            </div>
            <p className="text-gray-600 dark:text-gray-400 max-w-md leading-relaxed">
              A free, comprehensive Python learning platform for beginners aged 25+. 
              Learn Python 3 and build amazing chatbots with AI-powered assistance.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-6 text-lg">Learn</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/courses" className="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors">
                  All Courses
                </Link>
              </li>
              <li>
                <Link to="/courses/learn-python-3" className="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors">
                  Learn Python 3
                </Link>
              </li>
              <li>
                <Link to="/courses/build-chatbots" className="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors">
                  Build Chatbots
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Platform */}
          <div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-6 text-lg">Platform</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-primary-500 transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            © {currentYear} All rights reserved. Built by{' '}
            <a 
              href="https://iamdhee.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary-500 hover:text-primary-600 transition-colors font-semibold"
            >
              Dheepan Periasamy
            </a>
          </p>
          
          {/* Social Links */}
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a 
              href="https://github.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400 hover:bg-primary-500 hover:text-black transition-colors"
              aria-label="GitHub"
            >
              <Github size={20} />
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400 hover:bg-primary-500 hover:text-black transition-colors"
              aria-label="Twitter"
            >
              <Twitter size={20} />
            </a>
            <a 
              href="https://linkedin.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400 hover:bg-primary-500 hover:text-black transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




